var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgForbiddenCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 13.3327C10.9454 13.3327 13.3332 10.9449 13.3332 7.99935C13.3332 6.67057 12.8472 5.45528 12.0434 4.52151L4.522 12.0429C5.45577 12.8467 6.67105 13.3327 7.99984 13.3327Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 2.66602C5.05432 2.66602 2.6665 5.05383 2.6665 7.99935C2.6665 9.32813 3.15245 10.5434 3.95631 11.4772L11.4777 3.95583C10.5439 3.15196 9.32862 2.66602 7.99984 2.66602Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgForbiddenCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ForbiddenCircle.4695a201.svg";
export { ForwardRef as ReactComponent };